// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1CfQt","footer":"ModalCreateQualiphyProcedure_footer__1rWWL","additionData":"ModalCreateQualiphyProcedure_additionData__esajZ"};